import React from 'react';
import Navigation from '../navigation/Navigation';
import Footer from '../Footer/Footer';
import { Outlet } from 'react-router-dom';

const DashboardLayout = () => (
  <>
    <Navigation />
    <main id="main-content" className="dashboard-content" style={{ marginTop: '80px', minHeight: '80vh' }}>
      <Outlet />
    </main>
    <Footer />
  </>
);

export default DashboardLayout; 